import React, { useEffect } from 'react';
import { useRightSidebar } from '../contexts/RightSidebarContext';

interface SidebarCollapseHandlerProps {
  documentId: string | undefined;
  previousDocumentIdRef: React.MutableRefObject<string | undefined>;
}

export const SidebarCollapseHandler: React.FC<SidebarCollapseHandlerProps> = ({
  documentId,
  previousDocumentIdRef,
}) => {
  const rightSidebar = useRightSidebar();

  useEffect(() => {
    if (documentId && documentId !== 'new') {
      if (documentId !== previousDocumentIdRef.current) {
        previousDocumentIdRef.current = documentId;
        if (rightSidebar) {
          rightSidebar.collapseSidebar();
        }
      }
    }
  }, [documentId, rightSidebar, previousDocumentIdRef]);

  return null;
};






